import { createVNode as n, mergeProps as o } from "vue";
import d from "../node_modules/@pf-ui/pf-icon-svg/es/asn/RefreshOutlinedStandard.js";
import s from "../components/PfIcon.js";
const r = (e, t) => {
  const a = {
    ...e,
    ...t.attrs
  };
  return n(s, o(a, {
    icon: d
  }), null);
};
r.displayName = "RefreshOutlinedStandard";
r.inheritAttrs = !1;
export {
  r as default
};
